import React from 'react';
import { motion } from 'framer-motion';
export function TasteSection() {
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-136">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-137">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-138">
          {/* Left: Product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex justify-center" data-id="element-139">
            <img src="https://cdn.magicpatterns.com/uploads/rio1h7PrLwaVnQDrGetzpG/ChatGPT_Image_Jun_7,_2026,_02_10_17_PM.png" alt="Zesty Citrus Pouch" className="w-full max-w-md mix-blend-multiply" data-id="element-140" />
          </motion.div>

          {/* Right: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-141">
            <h2 className="font-headline text-4xl md:text-5xl text-charcoal" data-id="element-142">
              Bright, sharp, and refreshing enough to drink daily.
            </h2>

            <p className="text-xl text-gray-700" data-id="element-143">
              Citrus that tastes like a cold drink, not a supplement.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-144">
              No chalky aftertaste. No heavy artificial feel. Just clean citrus
              energy you can actually look forward to.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}